import { get, post } from '../../api';

const findSuggestions = async (requestId) =>
    Promise.resolve(
        get({ type: 'user', service: `/requests/${requestId}/linked-requests/suggestions` })
    ).then((response) => response.data?.suggestions || []);

const confirmSuggestion = async (requestId, suggestionId, data = {}) =>
    Promise.resolve(
        post({
            type: 'user',
            service: `/requests/${requestId}/linked-requests/suggestions/${suggestionId}/confirm`,
            data
        })
    ).then((response) => response.data);

const declineSuggestion = async (requestId, suggestionId) =>
    Promise.resolve(
        post({
            type: 'user',
            service: `/requests/${requestId}/linked-requests/suggestions/${suggestionId}/decline`,
            data: {}
        })
    ).then((response) => response.data);

const createLinkedRequest = async (requestId, data) =>
    Promise.resolve(
        post({ type: 'user', service: `/requests/${requestId}/linked-requests`, data })
    ).then((response) => response.data);

const requestLinkedService = {
    findSuggestions,
    confirmSuggestion,
    declineSuggestion,
    createLinkedRequest
};

export default requestLinkedService;
